import firebase from "@firebase/app"
import "@firebase/auth"
import "@firebase/firestore"

const config = {
  apiKey: process.env.GATSBY_GOOGLE_FIRESTORE_API_KEY,
  authDomain: process.env.GATSBY_GOOGLE_FIRESTORE_AUTHDOMAIN,
  projectId: process.env.GATSBY_GOOGLE_FIRESTORE_PROJECTID,
  storageBucket: process.env.GATSBY_GOOGLE_FIRESTORE_STORAGE_BUCKET,
  messagingSenderId: process.env.GATSBY_GOOGLE_FIRESTORE_MESSAGING_SENDER_ID,
  appId: process.env.GATSBY_GOOGLE_FIRESTORE_APP_ID,
  measurementId: process.env.GATSBY_GOOGLE_FIRESTORE_MEASUREMENT_ID,
}
// Initialize Firebase
let instance = null

export default function getFirebase() {
  if (typeof window !== "undefined") {
    if (instance) return instance
    instance = firebase.initializeApp(config)
    return instance
  }

  return null
}
